import { ShieldCheck } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { USERS } from "../helper/constants";
import { toast } from "react-toastify";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate role selection
    if (!role) {
      toast.error("Please select a role");
      return;
    }

    // Validate email format
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email");
      return;
    }

    // Check if user exists and password is correct
    const user = USERS[email];

    if (!user) {
      toast.error("Email not found");
      return;
    }

    if (user.password !== password) {
      toast.error("Invalid password");
      return;
    }

    // Validate that selected role matches user's actual role
    if (user.role !== role) {
      toast.error(
        `Invalid role. Please select ${user.role} role for this email.`,
      );
      return;
    }

    // Login successful
    login({
      email,
      role,
    });

    toast.success(`Welcome ${role.toUpperCase()} 👋`);

    setTimeout(() => {
      navigate("/dashboard");
    }, 1000);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 font-poppins ">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 animate-fade-in">
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-gray-200 rounded-full">
            <ShieldCheck className="h-10 w-10 text-primary" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">
          OpsBoard Dashboard Login
        </h2>
        <p className="text-center text-gray-500 mb-6">
          Select role to continue
        </p>

        <label className="block text-sm font-medium text-gray-600 mb-2">
          Email
        </label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-black outline-none transition mb-4"
        />
        <label className="block text-sm font-medium text-gray-600 mb-2">
          Password
        </label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-black outline-none transition mb-4"
        />
        <label className="block text-sm font-medium text-gray-600 mb-2">
          Role
        </label>

        <select
          value={role}
          onChange={(e) => setRole(e.target.value)}
          className="w-full border rounded-md px-3 py-2
    transition-all duration-200 ease-out
    focus:outline-none
    focus:border-black
     focus:ring-black
    focus:scale-[1.01]"
        >
          <option value="">Select role</option>
          <option value="admin">Admin</option>
          <option value="manager">Manager</option>
          <option value="viewer">Viewer</option>
        </select>

        {/* Login Button */}
        <button
          onClick={handleSubmit}
          type="submit"
          disabled={!email || !password || !role}
          className="w-full mt-6 bg-black text-white py-3 rounded-xl font-semibold
          hover:bg-gray-800 hover:scale-[1.02] transition-all duration-300  disabled:bg-gray-400
    disabled:cursor-not-allowed
    disabled:opacity-60"
        >
          Login
        </button>
      </div>
    </div>
  );
}
